<template>
	<layout-page-v2 class="appointment-day-view" icon="sethoscope" :h1="$t('base.watch.appointments')" :h2="$t('buttons.general.by_day')">
		<div slot="btn-group" class="btn-group">
			<button-icon-text-loading @click.native="openModal({ action: 'add' })" icon="plus-w" class="plus btn-add">{{ $t('buttons.actions.add_appointment') }}</button-icon-text-loading>
		</div>
		<error-box v-if="appointments.error" :error="appointments.error"/>
		<appointment-navigation :user_uid="user_uid" :watch_id="watch_id"/>
		<div class="calendar-container">
			<spinner v-if="appointments.loading" class="center"/>
			<div class="day-control">
				<button @click="decDay">&lt;</button>
				<div class="date">
					<div class="formated">{{ date_formated }}</div>
					<div class="day">{{ day_name }}</div>
				</div>
				<button @click="incDay">&gt;</button>
			</div>
			<div class="slots">
				<div v-for="slot in slots" :key="slot.id" class="slot" @click="hourClicked(slot.id)">
					<div class="hour">{{ slot.id }}:00</div>
					<div class="data" :class="{ appointments: slot.data.length }">
						<button class="appointment" v-for="appointment in slot.data" :key="appointment.id" @click.stop="appointmentClicked(appointment)">
							<div class="name">{{ appointment.name }}</div>
							<div class="location">{{ appointment.location }}</div>
						</button>
					</div>
				</div>
			</div>
		</div>
		<appointment-form v-if="modalBox.open" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</layout-page-v2>
</template>

<script>
import AppointmentNavigation from './AppointmentNavigation'
import AppointmentForm from './AppointmentForm'
export default {
	components: {
		AppointmentNavigation,
		AppointmentForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			state: {
				date: this.$moment(),
				day: null,
				day_offset: 0
			},
			appointments: {
				loading: false,
				data: [],
				error: null
			},
			modalBox: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		slots () {
			let appointments = new Map()
			this.appointments.data.forEach(e => {
				let hour = parseInt(this.$moment(e.date).format('HH'))
				if (appointments.has(hour))	{
					appointments.get(hour).push(e)
				} else {
					appointments.set(hour, [e])
				}
			})
			let slots = [], i;
			for (i = 0; i < 24; i++) {
				let list = appointments.get(i) || []
				slots.push({
					id: i,
					data: list
				})
			}
			return slots
		},
		date () {
			return this.state.date.format('YYYY-MM-DD')
		},
		date_formated () {
			return this.state.date.format('DD MMMM YYYY')
		},
		day_name () {
			return this.state.date.format('dddd')
		}
	},
	methods: {
		hourClicked (hour) {
			hour = `${hour.pad(2)}:00`
			this.openModal({ action: 'add', hour })
		},
		appointmentClicked (appointment) {
			this.$router.push({ name: 'WatchAppointmentEdit', params: { user_uid: this.user_uid, watch_id: this.watch_id, appointment_id: appointment.id, data: appointment } })
		},
		calcDate() {
			this.state.date = this.$moment().add(this.state.day_offset, 'd')
			this.state.day = this.state.date.dayOfYear()
			this.getAppointments()
		},
		decDay () {
			this.state.day_offset--
			this.calcDate()
		},
		incDay () {
			this.state.day_offset++
			this.calcDate()
		},
		getAppointments () {
			this.appointments.loading = true
			this.$api.appointments.getAllForToday(this, this.user_uid, this.watch_id, this.date).then(response => {
				this.$log.info('watch appointments', 'appointments.getAllForToday OK', response)()
				this.appointments.data = response.body
			}).catch(errors => {
				this.$log.error('watch appointments', 'appointments.getAllForToday ERROR', errors)()
				this.appointments.error = errors
			}).finally(() => {
				this.appointments.loading = false
			})
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.getAppointments()
			}
		}
	},
	beforeCreate () {
		this.$title('Day Calendar')
	},
	mounted () {
		this.getAppointments()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/appointments/AppointmentDayView.vue